export const toBoolean = (value: unknown): boolean => {
	if (typeof value === 'string') {
		const processedValue = value.toLowerCase().trim();
		return processedValue === 'true' || processedValue === '1';
	}
	if (typeof value === 'number') {
		return value !== 0;
	}
	return Boolean(value);
};
